<script lang="ts">
	import type { Snippet } from 'svelte';
	import { fly } from 'svelte/transition';

	interface Props {
		active: boolean;
		index?: number;
		children: Snippet;
		onclick?: (e: MouseEvent) => void;
	}

	let { active, index = 0, children, onclick }: Props = $props();
</script>

<li
	class="origin-center transform-gpu rounded-3xl transition-transform ease-in-out hover:scale-110 hover:shadow-sm"
	class:bg-green-2={active}
	class:text-stone-5={active}
	class:bg-stone-5={!active}
	class:text-brown-1={!active}
	transition:fly|global={{ y: -36, delay: index * 100 }}
>
	<button
		type="button"
		onclick={(e) => {
			e.stopPropagation();
			onclick?.(e);
		}}
		class="w-full whitespace-nowrap px-4 py-3"
	>
		{@render children()}
	</button>
</li>
